module.exports = __webpack_public_path__ + "img/Dantam Bridal 19.eb7a24ae.jpg";